import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const AreaChart = ({ dashboardData }) => {
  const chartOptions = useMemo(() => {
    const labelArr = [];
    const seriesArr = [];

    if (dashboardData?.weeklyRevenue?.length) {
      dashboardData.weeklyRevenue.forEach((item) => {
        // Use a fallback for dayOfWeek if it’s null
        labelArr.push(item.date || "N/A");
        seriesArr.push(item.revenueTotal);
      });
    }

    return {
      series: [
        {
          name: "Revenue",
          data: seriesArr,
        },
      ],
      options: {
        chart: {
          type: "area",
          height: 350,
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          colors: ["#1C1C1C"], // New curve color (teal green, change as needed)
          width: 1, // Reduce border width (default is 4)
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.1,
            stops: [0, 90, 100],
            colorStops: [
              {
                offset: 0,
                color: "#9E9E9E",
                opacity: 0.4,
              },
              {
                offset: 100,
                color: "#9E9E9E",
                opacity: 0.1,
              },
            ],
          },
        },
        labels: labelArr,
        yaxis: {
          opposite: false,
        },
        legend: {
          horizontalAlign: "left",
        },
      },
    };
  }, [dashboardData?.byOrder]);

  return (
    <div>
      <div id="chart">
        {chartOptions.series[0].data.length > 0 ? ( // Check if there's data to render
          <ReactApexChart
            options={chartOptions.options}
            series={chartOptions.series}
            type="area"
            height={350}
          />
        ) : (
          <p>No data available for the chart.</p>
        )}
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default AreaChart;
